import React, { Component, useState, useEffect } from 'react'
import Helper from '../Helper'
import useStateRef from 'react-usestateref';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { APPLICATION_JSON } from '../../middleware/types';
import Loader from '../Loader';
import { useSelector, useDispatch } from 'react-redux';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction'
import { Modal } from '../Modal/Modal';
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import CbMobileLogOut from './CbMobileLogOut';

export const PublicList = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage] = useState();
    const [friendList, setFriendList, friendListRef] = useStateRef('')
    const [profileId, setProfileId, profileIdRef] = useStateRef('')
    const [url, setUrl, setUrlRef] = useStateRef('')
    const [userName, setUserName, userNameRef] = useStateRef('')
    const [firstName, setFirstName, firstNameRef] = useStateRef('')
    const [responseList, setResponseList, responseListRef] = useStateRef('')
    const [addListToCart, setAddListToCart, addListToCartRef] = useStateRef()
    const [invalidProduct, setInvalidProduct, invalidProductRef] = useStateRef("");
    // const user = document.getElementById("listOwner")
    // const userNameList = user && user.getAttribute("userName") ? user.getAttribute("userName") + "'s Lists" : ""


    const [productDetailList, setProductDetailList, productDetailListRef] = useStateRef();
    const [productErrorMsg, setProductErrorMsg, productErrorMsgRef] = useStateRef('');
    const [responseListDetail, setResponseListDetail, responseListDetailRef] = useStateRef('')
    const [isModalopen, setIsModalOpen] = useState(false);
    const [eventNameAccend, setEventNameAccend] = useState(true);
    const [creationDateAccend, setCreationDateAccend] = useState(true);
    const [quantityAccend, setQuantityAccend] = useState(true);
    const [totalAccend, setTotalAccend] = useState(true);
    const history = useHistory()
    const dispatch = useDispatch();
    const [giftId, setGiftId, giftIdRef] = useStateRef()
    const GetCartCount = useSelector(state => state.miniCartItemCountReducer.response.payload)
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    //breadcrumbs object 
    const breadCrumbs = {
        "ancestors": [{
            label: userNameRef.current + "'s Lists",
            link: setUrlRef.current
        }],
        productName: ""
    };

    useEffect(() => {
        if (loaderStatus == true) {
			console.log("log in redeemShipping page loader true");
		} else {
			console.log("log in redeemShipping page loader false");
        // setIsLoading(true)
        var id = window.location.search
        setUrl(id)
        const params = new URLSearchParams(id);
        setProfileId(params.get('id'))
        var idd = params.get('id')
        if (idd) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/find-friends/shopping-list/${idd}`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.response != null) {
                        var friendListDetails = res && res.response && res.response.response
                        setFriendList(friendListDetails)
                        {
                            friendListRef.current && friendListRef.current.map((value, key) => {
                                return (
                                    (value && value.userName &&
                                        setUserName(value.userName)

                                    )
                                )
                            })
                        }
                        var firstName = userNameRef.current.split(" ")
                        setFirstName(firstName && firstName[0])
                        // setIsLoading(true)
                    } else {
                        console.log("Error result ---->>>>")

                    }
                })
        }
    }
    }, [])

    const handleFriendListSearch = (event) => {
        event.preventDefault();
        var formData = new FormData(event.target);
        //const formValue = Object.fromEntries(formData.entries());

        var shoppingListSearch = formData.get("searchProduct");

        const inputMap = {
            searchParam: shoppingListSearch,
            searchLists: "true",
            publicLists: "true"
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-search`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    var shoppingListDetatils = (JSON.parse(res.response)).response.matchedList
                    setFriendList(shoppingListDetatils)
                    document.getElementById("list-error").innerHTML = "";
                    document.getElementById("list-error").classList.add("d-none");


                    // setIsLoading(true)
                    // location.reload()
                } else {
                    //  setIsLoading(false)
                    var error = (JSON.parse(res.response)).response
                    document.getElementById("list-error").innerHTML = JSON.parse(error).errors;
                    document.getElementById("list-error").classList.remove("d-none");
                    document.getElementById("list-error").classList.add("d-block")
                    // location.reload()
                }
            })
    }
    async function handleAddProductToCart(event, index) {
        //event.preventDefault();
        // setIsLoading(true)

        Helper.clearErrorMsg()
        // setShoppingListErrorMsg()
        // setIsLoading(true)
        const selectedListsInArray = event.giftlistId && event.giftlistId ? [event.giftlistId] : []
        if (selectedListsInArray.length > 0) {
            var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/add-multiple-products-to-cart";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ selectedLists: selectedListsInArray }))
            if (res.result == "success") {

                setAddListToCart(JSON.parse(res.response).response.response.validproducts)
            //    handleSiteSpecDataLayer(JSON.parse(res.response).response.response.validproducts)
                if ((JSON.parse(res.response)).response.response.invalidProducts &&
                    (JSON.parse(res.response)).response.response.invalidProducts.length > 0) {
                    setInvalidProduct((JSON.parse(res.response)).response.response.invalidProducts)
                } else {
                    setInvalidProduct()
                }
                // setIsModalOpen(true)
                // updating cart count
                // var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/mini-cart-count`
                // dispatch(miniCartItemCountAction(Url))
                dispatch(updateProfileDetailsAction(true,"cart"));
                var addListBtn = document.getElementById("copy-modal-id");
                addListBtn.setAttribute("data-bs-toggle", "modal");
                addListBtn.setAttribute("data-bs-target", `#addProductToCartModal${index}`);
                addListBtn.click();
                // document.getElementById("listList").checked = false;
                setIsLoading(false)
            }
            else {
                //setShoppingListErrorMsg((JSON.parse(res.response)).errorMessage[0].message)
                setIsLoading(false)
            }
        } else {
            //setShoppingListErrorMsg("Please choose at least one shopping list to add the items from that list to your Cart.")
            setIsLoading(false)
        }
        //setSelectedProductIds()
    }


    function handleSiteSpecDataLayer(validateProduct){
		console.log("handleSiteSpecDataLayer firedddddd",validateProduct);
		let productList = []
        {validateProduct?.map((oneProduct)=>{
            let categoryList = [];
            let category = JSON.parse(oneProduct?.dataLayer_obj)
            const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];
    
            categoryList = categoryList1;
            const productMapDuplicate = {
                "productId": oneProduct.ProductId,
                "category": categoryList
            }
            let productMap = productMapDuplicate;
            productList.push(productMap)
        })}
		
		const page = {
			"type": "product",
			"products": productList
		}
		const PUBLICLIST_payload = {
			"page": page
		}
		window.ssRecsInfo = window.ssRecsInfo || {}
		window.ssRecsInfo = PUBLICLIST_payload
        window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': PUBLICLIST_payload}))
	}


    const handleCopy = (event) => {
        setGiftId(event)
        var copyModal = document.getElementById("addList");
        copyModal.setAttribute("data-bs-toggle", "modal");
        copyModal.setAttribute("data-bs-target", "#copyListModal");
        copyModal.click();
    }
    const handleSortingChange = (event) => {
        document.getElementById("eventName").classList.remove("sort-up")
        document.getElementById("eventName").classList.remove("sort-down")
        document.getElementById("creationDate").classList.remove("sort-up")
        document.getElementById("creationDate").classList.remove("sort-down")
        document.getElementById("quantity").classList.remove("sort-up")
        document.getElementById("quantity").classList.remove("sort-down")
        document.getElementById("total").classList.remove("sort-up")
        document.getElementById("total").classList.remove("sort-down")
        var accend = true
        if (event == "eventName") {
            accend = eventNameAccend
            if (eventNameAccend == true) {
                document.getElementById("eventName").classList.remove("sort-down")
                document.getElementById("eventName").classList.add("sort-up")
            } else {
                document.getElementById("eventName").classList.remove("sort-up")
                document.getElementById("eventName").classList.add("sort-down")
            }
        } else if (event == "creationDate") {
            accend = creationDateAccend
            if (creationDateAccend == true) {
                document.getElementById("creationDate").classList.remove("sort-down")
                document.getElementById("creationDate").classList.add("sort-up")
            } else {
                document.getElementById("creationDate").classList.remove("sort-up")
                document.getElementById("creationDate").classList.add("sort-down")
            }
        } else if (event == "quantity") {
            accend = quantityAccend
            if (quantityAccend == true) {
                document.getElementById("quantity").classList.remove("sort-down")
                document.getElementById("quantity").classList.add("sort-up")
            } else {
                document.getElementById("quantity").classList.remove("sort-up")
                document.getElementById("quantity").classList.add("sort-down")
            }
        } else if (event == "total") {
            accend = totalAccend
            if (totalAccend == true) {
                document.getElementById("total").classList.remove("sort-down")
                document.getElementById("total").classList.add("sort-up")
            } else {
                document.getElementById("total").classList.remove("sort-up")
                document.getElementById("total").classList.add("sort-down")
            }
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/friend-list-sort/${profileIdRef.current}/${event}/${accend}`, {
            method: 'GET',
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    if (event == "eventName") {
                        if (eventNameAccend == true) {
                            setEventNameAccend(false)
                        } else {
                            setEventNameAccend(true)
                        }
                    } else if (event == "creationDate") {
                        if (creationDateAccend == true) {
                            setCreationDateAccend(false)
                        } else {
                            setCreationDateAccend(true)
                        }
                    } else if (event == "quantity") {
                        if (quantityAccend == true) {
                            setQuantityAccend(false)
                        } else {
                            setQuantityAccend(true)
                        }
                    } else if (event == "total") {
                        if (totalAccend == true) {
                            setTotalAccend(false)
                        } else {
                            setTotalAccend(true)
                        }
                    }
                    setFriendList(JSON.parse(res.response).response)
                } else {
                    console.log("Error result ---->>>>")
                }
            })
    }
    function handlePrintPage() {
        window.print()
    }
    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail c-shopping-list-mobile-view`} >
            <div className="row">
                <div className="col-md-11">
                    {userNameRef.current && userNameRef.current != null &&
                        <BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="FriendList"></BreadCrumbsContainer>
                    }
                </div>
                <div className="col-12 col-md-1 d-none d-lg-block" style={{ marginLeft: "-20px" }}>
                    <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                        <i className="bi bi-printer-fill" aria-hidden="true"></i>Print
                    </button>
                </div>
            </div>
            <div class="col-lg-9 m-lg-auto">
                <div class="row my-3 my-md-0">
                    <div class="col-6 col-md-6">
                        <h1 id="listOwner" class="c-account-list-heading" userName={userNameRef.current}>{userNameRef.current}'s Lists</h1>
                    </div>
                    <div class="col-6 col-md-6 d-lg-none">
                        <CbMobileLogOut userName={userNameRef.current} firstName={firstNameRef.current} />
                    </div>
                </div>
                <div class="alert alert-danger" role="alert" style={{ display: 'none' }} id="list-error"></div>
                <div class="row c-shopping-list-page align-items-center my-3">
                    {/* <form method="post" action="/account/list-public" id="searchShoppingLists" data-hs-cf-bound="true">

                        <div class="col-12 col-md-9">
                            <div class="row g-1">
                                <label for="inputPassword3" class="d-none d-md-flex col-md-3 col-form-label c-shopping-list-label">Search Lists:</label>

                                <div class="col-9 col-md-7">
                                    <input maxlength="25" name="searchParam" id="searchLists" placeholder='List Name, Product Name, or Item #' type="text" value="" class="form-control" />

                                </div>
                                <div class="col-2 col-md-2">
                                    <input type="button" class="btn btn-primary c-btn-search" value="Search" id="searchListsButton" />
                                </div>

                            </div>
                        </div>

                    </form> */}

                    <form className='col-8 col-md-9' onSubmit={handleFriendListSearch} method="post" action="/" id="searchShoppingLists" data-hs-cf-bound="true">
                        <div className="">
                            <div className="row g-1">
                                <label for="inputPassword3" className="d-none d-md-flex col-md-3 col-form-label c-shopping-list-label">Search Lists:</label>
                                <div className="col-8 col-md-7">
                                    <input className="form-control" placeholder="List Name, Product Name, or Item #" maxlength="25" name="searchProduct" id="searchLists" type="text" />
                                </div>
                                <div className="col-2 col-md-2">
                                    <input type="submit" name="shoppingListSearch" className="btn btn-primary c-btn-search" value="Search" id="searchListsButton" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="c-list-table c-public-lists">
                            <h1 class="c-mobile-list-heading d-block d-md-none">My Lists</h1>

                            <ul class="c-shop-list">
                                <li class="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                    <div class="c-list-left">
                                        <span class="c-shop-list-content c-shop-list-name">Name <Link className="sort" onClick={() => handleSortingChange("eventName")} id="eventName"></Link></span>
                                        <span class="c-shop-list-content c-shop-list-created">Created on <Link className="sort" onClick={() => handleSortingChange("creationDate")} id="creationDate"></Link></span>
                                        <span class="c-shop-list-content c-shop-list-items"># Items <Link className="sort" onClick={() => handleSortingChange("quantity")} id="quantity"></Link></span>
                                        <span class="c-shop-list-content c-shop-list-total">Total <Link className="sort" onClick={() => handleSortingChange("total")} id="total"></Link></span>
                                    </div>
                                    <div class="c-list-right">
                                        <span></span>
                                    </div>
                                </li>
                            </ul>

                            <ul class="c-shop-list list-account list-wishlist list-public" id="list-display">
                                {friendListRef.current && friendListRef.current.map((value, index) => {
                                    return (
                                        (value && value.Name &&
                                            <li class="c-shop-list-item c-shop-list-body">
                                                <div class="c-list-left">
                                                    <span class="c-shop-list-content c-shop-list-name">
                                                        <Link id={value.giftlistId ? value.giftlistId : ""} class="fw-bold"></Link>
                                                        <p></p>
                                                        <Link to={`/account/list-detail-public?giftlistId=${value.giftlistId}&profileId=${profileIdRef.current}`} className="fw-bold">{value.Name ? value.Name : ""}</Link>
                                                        <p>{value.Description ? value.Description : ""}</p>
                                                    </span>
                                                    <span class="c-shop-list-content c-shop-list-created"><span class="d-block d-md-none c-shop-mobile-label">Created On</span>{value.comments ? value.comments : ""}</span>
                                                    <span class="c-shop-list-content c-shop-list-items"><span class="d-block d-md-none c-shop-mobile-label">Items</span>{value.quantity ? value.quantity : ""}</span>
                                                    <span class="c-shop-list-content c-shop-list-total">
                                                        <span class="d-block d-md-none c-shop-mobile-label">Total</span>
                                                        <strong>{value.total ? value.total : ""}</strong>
                                                        {value && value.retailPrice && <span class="c-list-retail"><i>{`Retail `}<del>{value.retailPrice}</del></i></span>}
                                                    </span>

                                                </div>
                                                <p id="copy-modal-id"></p>
                                                <p id="addList"></p>
                                                <div class="c-list-right text-end">
                                                    {/* <button type="button" className="btn c-shop-btn c-list-btn-action" data-bs-toggle="modal" data-bs-target="#copyListModal">Copy</button> */}
                                                    <button type="button" className="btn c-shop-btn c-list-btn-action c-list-btn-items-mobile" data-bs-toggle="modal" index={index} data-bs-target={`#copyListModal${index}`}>Copy</button>
                                                    <input type="button" className="btn c-shop-btn c-list-btn-action" onClick={() => handleAddProductToCart(value, index)} value="Add to Cart" />
                                                </div>
                                                <Modal giftlistId={value && value.giftlistId && value.giftlistId} index={index} props={addListToCartRef.current} invalidProduct={invalidProductRef.current} />
                                            </li>
                                        )
                                    )
                                })}
                            </ul>
                            {/* <Modal props={productDetailListRef.current ? productDetailListRef.current : addListToCartRef.current} /> */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
